/*
 * Live delivery promise.
 *
 * Reads the current time in Dubai (not the visitor's timezone — a buyer in
 * London sending flowers to Dubai needs Dubai's clock) and states what the
 * shop can actually honour right now:
 *
 *   during hours  -> "Order within 2h 14m — delivered by 11:45 PM today"
 *   near closing  -> "Order in the next 12 minutes for delivery tonight"
 *   after hours   -> "Order now — first delivery tomorrow from 10:00 AM"
 *
 * It never promises a slot the shop cannot serve.
 */
(function () {
  var SELECTOR = '[data-delivery-promise]';

  // The Arabic storefront rendered this line in English, in the most prominent
  // spot on the page. The strings live here rather than in a locale file
  // because the sentences are assembled from a clock reading at run time and
  // this asset is plain JS with no Liquid; <html lang> is set per locale by the
  // layout, so it is a reliable switch.
  var isArabic = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;

  var AR_DIGITS = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  function arDigits(str) {
    return String(str).replace(/[0-9]/g, function (d) { return AR_DIGITS[+d]; });
  }

  function dubaiNow() {
    // Asia/Dubai is UTC+4 year round, so a fixed offset is safe and avoids
    // relying on Intl timezone support in older mobile browsers.
    var now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() + 240) * 60000);
  }

  function fmtTime(date) {
    var h = date.getHours();
    var m = date.getMinutes();
    var suffix = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12;
    if (h12 === 0) h12 = 12;
    var text = h12 + ':' + (m < 10 ? '0' + m : m);
    if (isArabic) return arDigits(text) + ' ' + (h >= 12 ? 'م' : 'ص');
    return text + ' ' + suffix;
  }

  function message(el) {
    var openHour = parseInt(el.getAttribute('data-open-hour'), 10) || 10;
    var closeHour = parseInt(el.getAttribute('data-close-hour'), 10) || 24;
    var lead = parseInt(el.getAttribute('data-lead-minutes'), 10) || 45;

    var now = dubaiNow();
    var hour = now.getHours();
    var minsNow = hour * 60 + now.getMinutes();
    var opensAt = openHour * 60;
    var closesAt = closeHour * 60;

    var opensText = isArabic ? arDigits(openHour + ':45') + ' ص' : openHour + ':45 AM';

    // Before opening: the earliest possible arrival is opening + the 45 min run.
    if (minsNow < opensAt) {
      if (isArabic) return 'اطلب الآن &mdash; التوصيل من ' + opensText + ' اليوم، أو اختر وقتك';
      return 'Order now &mdash; delivered from ' + opensText + ' today, or pick your own time';
    }

    if (minsNow >= closesAt) {
      if (isArabic) return 'اطلب الآن &mdash; التوصيل من ' + opensText + ' غداً، أو اختر وقتك';
      return 'Order now &mdash; delivered from ' + opensText + ' tomorrow, or pick your own time';
    }

    var minsLeft = closesAt - minsNow;

    // Too close to closing for the courier to still make it out today. This
    // used to invite an order "in the next N minutes for delivery tonight" for
    // the last 40 of those minutes, which contradicted its own condition - and
    // since 2026-08-17 also contradicts the scheduler, which stops offering
    // today the moment the last run can no longer land before midnight.
    if (minsLeft <= lead) {
      if (isArabic) return 'اطلب الآن &mdash; التوصيل من ' + opensText + ' غداً';
      return 'Order now &mdash; delivered from ' + opensText + ' tomorrow';
    }

    // The 45 minutes run from the moment the order is placed, so the only
    // honest arrival time is right now + 45. Quoting a longer ordering window
    // alongside it would contradict the promise.
    // Both halves of the offer in one line: the fast default, and the fact that
    // a specific time can be chosen instead. Competitors bury the second half
    // at checkout, which is exactly where hesitation costs the sale.
    var arrival = new Date(now.getTime() + lead * 60000);
    if (isArabic) return 'اطلب الآن &mdash; يصلك الساعة ' + fmtTime(arrival) + '، أو اختر وقتك';
    return 'Order now &mdash; delivered by ' + fmtTime(arrival) + ', or pick your own time';
  }

  function render() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var target = el.querySelector('[data-delivery-promise-text]');
      if (!target) continue;
      var text = message(el);
      if (target.innerHTML !== text) target.innerHTML = text;
      el.classList.add('delivery-promise--live');
    }
  }

  function start() {
    render();
    // A minute is enough resolution; anything faster is noise the visitor
    // cannot perceive and only costs battery.
    setInterval(render, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Sections re-render in the theme editor without a page load.
  document.addEventListener('shopify:section:load', render);
})();
